import { reportsApi } from '../reports.api';
import { PeriodDto, ReportSaleManagerDto } from '@sr/dto';

export type SalesQuery = {
  year: number,
  month: number,
  managerId: number
};

const injectedApi = reportsApi.injectEndpoints({
  endpoints: (builder) => ({
    getSalesPeriods: builder.query<PeriodDto[], void>({
      query: () => ({
        url: 'sales/periods',
        method: 'GET',
      }),
    }),
    getSales: builder.query<ReportSaleManagerDto, SalesQuery>({
      query: ({ year, month, managerId }: SalesQuery) =>
        `sales?year=${year}&month=${month}${managerId ? `&managerId=${managerId}` : ''}`,
    }),
    }),
});

export const salesApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['sales'],
  endpoints: {},
});